// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"af7dd064","551":"2a89d47a"}[chunkId] + ".chunk.css";
};